module.exports = __webpack_public_path__ + "static/img/jigou-hangzhou-bottom.5205b50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-hangzhou-bottom.png
// module id = vyZc
// module chunks = 2